export const multiSpace = /\s\s+/g;
